var map = {
	"./aparthotelclub/image_placeholder_new.png": 76682,
	"./beachful/image_placeholder_new.png": 48627,
	"./castlepedia/image_placeholder_new.png": 93319,
	"./cocktayl/image_placeholder_new.png": 19008,
	"./image_placeholder_new.png": 12162,
	"./luxresortclub/image_placeholder_new.png": 93557,
	"./parkful/image_placeholder_new.png": 17409,
	"./prefabworld/image_placeholder_new.png": 93988,
	"./rooftopclub/image_placeholder_new.png": 24567,
	"./spaclub/image_placeholder_new.png": 69942,
	"./worldcasino/image_placeholder_new.png": 87329,
	"./zoopedia/image_placeholder_new.png": 46508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55995;